<template>
  <div class="agenda">
    <div class="agenda_content">
      <div class="agenda_content_left">
        <div v-for="(item,index) in timeList" v-if="timeList.length>1" :class="activeIndex==index?'agenda_content_left_item active_agenda_content_left_item':'agenda_content_left_item'"
        @click="timeClick(index,item)">
          <span style="color: #CCCCCC;font-size: 24px;font-style: italic;display: inline-block;padding-right: 20px">{{item.name.split('.')[0]}}</span>
          <span style="color: #CCCCCC;font-size: 24px;display: inline-block;">/</span>
          <span :style="activeIndex==index?'color: #0D51FF;font-size: 42px;font-style: italic':'color: #CCCCCC;font-size: 42px;font-style: italic'">{{item.name.split('.')[1]}}</span>
        </div>
      </div>

      <div class="agenda_content_right">
        <div class="agenda_content_right_tabs" v-if="tabs.length>1">
          <div
              :class="tabsIndex==0?'agenda_content_right_tabs_item agenda_content_right_tabs_item_leftActive':'agenda_content_right_tabs_item agenda_content_right_tabs_item_rightActive'"
              v-for="(item,index) in tabs" @click="tabsClick(index)">
            {{item.title}} {{item.startTime}}-{{item.endTime}}
          </div>
        </div>

        <div class="agenda_content_right_tabs" v-else>
          <div
              class="agenda_content_right_tabs_one"
              v-for="(item,index) in tabs" @click="tabsClick(index)">
            {{item.title}} {{item.startTime}}-{{item.endTime}}
          </div>
        </div>

        <slot>

        </slot>

      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Agenda",
  data(){
    return{
      activeIndex:0,
      tabsIndex:0,
      timeList:[],
      tabs:[],
    }
  },
  computed:{

  },
  async mounted() {
    await this.getTimeList()
    await this.getTabsList()
  },
  methods:{
    async getTimeList(){
      const {data} = await this.$axios.get('/forum/dictionary/list',{
        params:{
          type:8
        }
      })
      this.timeList = data.data
    },
    timeClick(index){
      this.activeIndex = index
      // 选择年份时间时,tab自动归0
      this.tabsIndex = 0
      this.getTabsList()
    },
    async getTabsList(){
      const {data:info} = await this.$axios.get('/forum/agenda/date',{
        params:{
          dateFull:this.timeList[this.activeIndex].value
        }
      })
      this.tabs = info.data
      this.$emit('change',this.tabs[this.tabsIndex].id)
    },
    tabsClick(index){
      this.tabsIndex = index
      this.$emit('change',this.tabs[this.tabsIndex].id)
    }
  }
}
</script>

<style lang="scss" scoped>
.agenda{
  width: 1201px;
  height: auto;
  margin: auto;
  background: #fff;
  padding-bottom: 50px;
  .agenda_content{
    width: 1201px;
    height: 750px;
    margin: auto;
    display: flex;
    .agenda_content_left{
      box-shadow: 0 5px 10px 0 rgba(0,0,0,.1);
      width: 220px;
      height: 750px;
      border: 1px solid #EEEEEE;
      border-right: none;
      background: url("../static/image/agenda/image_1.png");
      background-size: contain;
      .agenda_content_left_item{
        height: 100px;
        width: 100%;
        border-bottom: 1px solid #EEEEEE;
        text-align: center;
        line-height: 100px;
        font-family: Roboto,sans-serif;
        cursor:pointer;
      }
      .active_agenda_content_left_item{
        border-left: 10px solid #0D51FF;
        background: #EEF3FF;
        width: (100%-10)px
      }
    }
    .agenda_content_right{
      width: 981px;
      height: 100%;
      border: 1px solid #EEEEEE;
      //border-left: none;
      padding: 21px 0 0 21px;
      .agenda_content_right_tabs{
        display: flex;
        justify-content: space-between;
        height: 48px;
        border-bottom: 2px solid #eee;
        .agenda_content_right_tabs_item{
          width: 474px;
          height: 100%;
          line-height: 46px;
          text-align: left;
          color: #1A1D4A;
          font-size: 18px;
          padding-left: 20px;
          overflow: hidden;
          cursor: pointer;
        }
        .agenda_content_right_tabs_one{
          height: 100%;
          width: 100%;
          line-height: 46px;
          text-align: left;
          color: #fff;
          font-size: 18px;
          padding: 0 20px;
          overflow: hidden;
          cursor: pointer;
          background: linear-gradient(90deg, #0D51FF 0%, #AFFFEF 100%);
        }
      }
      .agenda_content_right_tabs_item_leftActive:nth-child(1){
        background: url("../static/image/agenda/image_1_1.png") no-repeat;
        background-size: contain;
        color: #fff;
      }
      .agenda_content_right_tabs_item_leftActive:nth-child(2){
        background: url("../static/image/agenda/image_2_2.png") no-repeat;
        background-size: contain;
        color: #1A1D4A;
      }

      .agenda_content_right_tabs_item_rightActive:nth-child(1){
        background: url("../static/image/agenda/image_1_2.png") no-repeat;
        background-size: contain;
        color: #1A1D4A;
      }
      .agenda_content_right_tabs_item_rightActive:nth-child(2){
        background: url("../static/image/agenda/image_2_1.png") no-repeat;
        background-size: contain;
        color: #fff;
      }

    }
  }
}
</style>